<template>
<v-card>
  <v-card-title>
      <v-layout justify-space-between row>
        <h2 class="checkout-h3">{{selectedSeat.identificacao | getRow}} {{selectedSeat.identificacao | getNumber}} <v-icon small :color="selectedSeat.cor ? `${selectedSeat.cor}` : '#e0e0e0'">brightness_1</v-icon> {{selectedSeat.nome_produto_vinculado}}</h2>
      </v-layout>
    </v-card-title>
    <v-divider></v-divider>
  <v-list three-lines class="sector-list pt-0">
    
    <template v-for="(product, index) in reservedProduct">
      <v-layout
        justify-space-between
        row
        class="product-type-info"
        :key="`${product.codigo_produto} + ${index}`"
      >
        <v-flex xs9 sm10 lg10>
          <h3 class="checkout-h3">{{ product.nome_tipo }}</h3>
          <h4 class="product-price" v-html="productPriceDetails(product)">
          </h4>
        </v-flex>
        <v-flex shrink>
          <v-layout>
              <div
                class="v-expansion-panel__header__icon"
              >
              </div>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider :key="index"></v-divider>
    </template>
    
  </v-list>
  <v-layout justify-space-around row class="pa-3">
    <span class="secondary--text link mt-1 action-btn" @click="remove">Remover do Carrinho</span>
    <!-- <v-divider vertical></v-divider>
    <span class="secondary--text link mt-1 action-btn">Alterar Ingresso</span> -->
  </v-layout>
</v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data(){
    return {
      reservedSeat: null
    }
  },
  mounted() {
  },
  
  filters: {
    getNumber: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').pop();
    },
    getRow: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.split(';').shift();
    },
  },
  computed: {
    ...mapGetters({
      sector: 'selectedSector',
      eventName: 'eventName'
    }),
    selectedSeat() {
      return this.$store.getters.selectedSeat;
    },
    reservedProduct() {
      let selectedSector = this.$store.getters.selectedSector.products
      let selectedSeat =  this.selectedSeat
      
      let productReservation = selectedSector.filter(ss => ss.reserved).map(el => {
          if(el.seats.includes(selectedSeat.codigo_assento)) return el
          return null
      }).filter(co => co)

      this.reservedSeat = productReservation
      return productReservation
    }
  },
  methods: {
    async remove() {
      if(this.reservedSeat[0].quantidade === 1) this.reservedSeat[0].reserved = false  
      this.reservedSeat[0].codigo_obj = this.selectedSeat.codigo_obj
      this.reservedSeat[0].identificacao = this.selectedSeat.identificacao
      this.reservedSeat[0].codigo_assento = this.selectedSeat.codigo_assento
      await this.$store.dispatch('removeCartProduct', this.reservedSeat[0]);
      await this.$store.dispatch('decrementProductsQuantity', this.reservedSeat[0]);
      
    
        this.selectedSeat.reserved = false
        this.selectedSeat.selecionado = false
        this.cancelReservedSeat()
        await this.$store.dispatch('setRemovedSeat', this.selectedSeat)
    },
    cancelReservedSeat() {
       this.selectedSeat.op = false
       this.$store.dispatch('setSelectedSeat', this.selectedSeat)
    },
    productPriceDetails(product) {
      const value = this.$options.filters.currency(product.valor * 100);
      const tax = product.valor_conveniencia
        ? ` + ${this.$options.filters.currency(
            product.valor_conveniencia * 100
          )} taxa`
        : '';
      const lote = ` (Lote ${product.lote})`;
      return `<span style="font-size: 16px; color: #1976d2">${value}</span>${tax}${this.eventName && this.eventName.includes('Natal Luz') ? '' : lote}`;
    },
  }
}
</script>

<style scoped>
.action-btn {
    cursor: pointer;
}
</style>
<style lang="stylus">
@import '~@/assets/product/productsPanel.styl'
@import "~@/assets/product/productTypes.styl"
</style>
